module.exports = __webpack_public_path__ + "media/images/icons/plus-fcaa7293ade646dc04b2995d01ebf6b2.svg";